import React from 'react'
import SettingsDesktop from './SettingsDesktop'
import SettingsMobileView from './components/SettingsMobileView'
import { useSettings } from './hooks/useSettings'
import useMobile from '../../hooks/useMobile'

const Settings = () => {
    const isMobile = useMobile()
    const logic = useSettings()

    return isMobile ? (
        <SettingsMobileView logic={logic} />
    ) : (
        <SettingsDesktop logic={logic} />
    )
}

export default Settings
